/**
 * Scroll funkcie pre Tabulator tabuľky.
 * Používame row komponent (nie id) – scrollToRow s row objektom funguje spoľahlivo vo všetkých tabuľkách.
 * @param {object} table - Tabulator inštancia (ref.current)
 * @param {string} [idField='id'] - názov poľa pre id riadka (napr. 'row_id' pre OtkCompanyStatisticsPeriodAdd) – používa sa len keď tabuľka nemá getRows("range")
 */

function scrollHolderToBottom(holder) {
  if (!holder) return false;
  const target = Math.max(0, holder.scrollHeight - holder.clientHeight);
  holder.scrollTop = target;
  holder.dispatchEvent(new Event('scroll', { bubbles: true }));
  return true;
}

export function scrollToFirst(table, idField = "id") {
  if (!table?.getRows) return;
  const range = table.getRows("range");
  if (range?.length) table.scrollToRow(range[0], "top", true);
}

/**
 * Scroll o jednu stránku hore – prvý viditeľný riadok sa stane posledným viditeľným.
 */
export function scrollUp(table, idField = "id") {
  if (!table?.getRows) return;
  const visible = table.getRows("visible");
  const range = table.getRows("range");
  if (!visible?.length || !range?.length) return;
  const firstVisibleRow = visible[0];
  const firstPos = firstVisibleRow.getPosition();
  if (!firstPos) return;
  const pageSize = visible.length - 1;
  const targetPos = Math.max(1, firstPos - pageSize);
  const targetRow = range[targetPos - 1];
  if (targetRow) table.scrollToRow(targetRow, "top", false);
}

export function scrollDown(table, idField = "id") {
  if (!table?.getRows) return;
  const visible = table.getRows("visible");
  if (!visible?.length) return;
  const lastRow = visible[visible.length - 1];
  if (lastRow) table.scrollToRow(lastRow, "top", true);
}

export function scrollToLast(table, idField = "id") {
  if (!table) return;
  const holder = table?.rowManager?.element;
  if (holder) {
    const apply = () => scrollHolderToBottom(holder);
    apply();
    requestAnimationFrame(() => {
      apply();
      requestAnimationFrame(apply);
    });
    return;
  }
  if (!table?.getRows) return;
  const range = table.getRows("range");
  if (range?.length) table.scrollToRow(range[range.length - 1], "bottom", true);
}
